export const BetStateEnum = {
    Rejected: -1,
    NotResulted: 0,
    Accepted: 1,
    Returned: 2,
    Lost: 3,
    Won: 4,
    CashOut: 5,
    Rollbacked: -2
};

export const BetStateViewEnum = {
    [BetStateEnum.Rejected]: 'REJECTED',
    [BetStateEnum.NotResulted]: 'NOT RESULTED',
    [BetStateEnum.Accepted]: 'PENDING',
    [BetStateEnum.Returned]: 'RETURNED',
    [BetStateEnum.Lost]: 'LOST',
    [BetStateEnum.Won]: 'WON',
    [BetStateEnum.CashOut]: 'CASHOUT',
    [BetStateEnum.Rollbacked]: 'ROLLBACKED'
};